/* istanbul ignore file */

/** Minimum scale */
export const MIN_SCALE = 1;
/** Maximum Scale */
export const MAX_SCALE = 50;

/** Scale the ratio base */
export const BASE_SCALE_RATIO = 1;
/** The maximum zoom ratio when the mouse zooms in, adjustable */
export const WHEEL_MAX_SCALE_RATIO = 1;
